
<div class="form-group">
  <label>Registration number</label>
  <input (keydown.enter)="lookup()" type="text" name="reg" maxlength="7" [(ngModel)]="lookupModel.registrationNumber" class="form-control" />
</div>
<div class="form-group">
  <label>Email</label>
  <input (keydown.enter)="lookup()" type="text" [(ngModel)]="lookupModel.email" class="form-control" />
</div>
<div class="form-group">
  <label>Person ID</label>
  <input (keydown.enter)="lookup()" type="text" [(ngModel)]="lookupModel.personId" class="form-control" />
</div>
<div class="form-group">
  <label>GPhC ID</label>
  <input (keydown.enter)="lookup()" type="text" [(ngModel)]="lookupModel.gphcId" class="form-control" />
</div>


<app-collapsible [trigger]="errors.length">
  @for (error of errors; track error) {
    <div class="form-error" style="margin-bottom:10px;">{{error}}</div>
  }
</app-collapsible>


<app-collapsible [trigger]="!loading">
  <button [disabled]="!allowSubmit" class="btn btn-primary btn-block btn-lg" (click)="lookup()">Find user</button>
</app-collapsible>

<app-collapsible [trigger]="loading" class="spinner-container">
  <div style="display:flex;align-items: center;">
    <div style="flex-grow:1"></div>
    <app-spinner [tiny]="true"></app-spinner>

    <label style="margin-left: 20px;">{{loadingMessage}}</label>
    <div style="flex-grow:1"></div>
  </div>
</app-collapsible>


<h4 class="p-3">Search for student details</h4>

<div class="form-group">
  <label>Pre-entry number</label>
  <input (keydown.enter)="lookupStudent()" type="text" name="prereg" maxlength="7" [(ngModel)]="lookupModel.PreEntryNumber" class="form-control"
    />
  </div>


  <app-collapsible [trigger]="studentErrors.length">
    @for (error of studentErrors; track error) {
      <div class="form-error" style="margin-bottom:10px;">{{error}}</div>
    }
  </app-collapsible>

  <app-collapsible [trigger]="!loadingStudent">
    <button [disabled]="!allowStudentSubmit" class="btn btn-primary btn-block btn-lg" (click)="lookupStudent()">Find student</button>
  </app-collapsible>

  <app-collapsible [trigger]="loadingStudent" class="spinner-container">
    <div style="display:flex;align-items: center;">
      <div style="flex-grow:1"></div>
      <app-spinner [tiny]="true"></app-spinner>

      <label style="margin-left: 20px;">{{loadingStudentMessage}}</label>
      <div style="flex-grow:1"></div>
    </div>
  </app-collapsible>